module.exports = __webpack_public_path__ + "assets/images/profiles/1970-1.jpg?v=528fdfff";